import { type TagModel } from '@/shared/api'
import { showDeleteConfirmationModal } from '@/shared/lib/antd-utils'
import { COMMON_COLUMN_WIDTH } from '@/shared/lib/styling'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Space, type TableProps } from 'antd'
import { useUnit } from 'effector-react'

import { tagDeleted } from '../../model/tag.model'

interface useTagsTableColumnsProps {
  onEdit: (tagId: number) => void
}
export const useTagsTableColumns = ({
  onEdit: handleEdit,
}: useTagsTableColumnsProps): TableProps<TagModel>['columns'] => {
  const deleteTag = useUnit(tagDeleted)
  const handleDelete = (id: number) => {
    showDeleteConfirmationModal({
      onConfirm: () => {
        deleteTag({ id })
      },
    })
  }

  return [
    {
      title: 'Наименование',
      dataIndex: 'name',
      key: 'name',
      render: (_, tag) => tag.name,
    },
    {
      title: '',
      width: COMMON_COLUMN_WIDTH.ACTIONS,
      key: 'actions',
      align: 'center',
      render: (_, tag) => (
        <Space size="middle">
          <Button onClick={() => handleEdit(tag.id)} icon={<EditOutlined />} />
          <Button
            onClick={() => handleDelete(tag.id)}
            icon={<DeleteOutlined style={{ color: 'red' }} />}
          />
        </Space>
      ),
    },
  ]
}
